import type { ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

type TileSide = 'front' | 'back';

type Context = {
  tileSide: TileSide;
  toggleTileSide: (tileSide: TileSide) => void;
};

export const TileSideToggleContext = createContext<Context>({
  tileSide: 'front',
  toggleTileSide: () => null,
});

type Provider = {
  children: ReactNode;
};

export const TileSideToggleProvider = ({ children }: Provider) => {
  const [tileSide, toggleTileSide] = useState<'front' | 'back'>('front');

  return (
    <TileSideToggleContext.Provider value={{ tileSide, toggleTileSide }}>
      {children}
    </TileSideToggleContext.Provider>
  );
};

export const useTileSideToggle = () => {
  const context = useContext(TileSideToggleContext);
  if (typeof context === 'undefined') {
    throw new Error(
      'useSideToggleContext: Attempting to access undefined context, possibly outside of `SideToggleProvider`'
    );
  }
  return context;
};
